import React from "react";
import { store } from '../../store/store';
import { push } from 'react-router-redux';
import MobileWrapper from '../../layouts/MobileWrapper';
import { Grid,List } from 'antd-mobile';
import { connect } from 'react-redux';
import '../../assets/font-awesome-4.7.0/css/font-awesome.min.css';
import './style.css';
import { fetchEmployeeTips,fetchEmployeeImportantTips } from '../../actions/employee-actions';

const Item = List.Item;
class MobileHome extends React.Component {
	componentWillMount() {
		this.props.fetchEmployeeTips();
		this.props.fetchEmployeeImportantTips();
	}
	render() {
		const { mobileUserInfo } = this.props.user
		let navList = [], i=0;
		if(mobileUserInfo && mobileUserInfo.Menus.length !== 0){
			mobileUserInfo.Menus.forEach(v=>{
				if(v.icon === "home" && v.children.length !== 0){
					v.children.forEach(list=>{
						navList[i]={
							icon: (<span className={list.icon} />),
							text: list.name,
							path: list.path
						}
						i++;
					})
				}
			})
		}
		// const navList = [{
		// 	icon: (<span className="fa fa-clock-o fa-2x" />),
		// 	text: '申请加班',
		// 	path:'/mobile/mobile-apply-overtime'
		// }, {
		// 	icon: (<span className="fa fa-history fa-2x" />),
		// 	text: '申请调休',
		// 	path:'/mobile/mobile-apply-break-down-create'
		// }, {
		// 	icon: (<span className="fa fa-id-card-o fa-2x" />),
		// 	text: '考勤记录',
		// 	path:'/mobile/mobile-attendance-detail'
		// }, {
		// 	icon: (<span className="fa fa-calendar fa-2x" />),
		// 	text: '行事历',
		// 	path:'/mobile/mobile-calendar'
		// }, {
		// 	icon: (<span className="fa fa-file-sound-o fa-2x" />),
		// 	text: '制度与公告',
		// 	path:'/mobile/mobile-announcement'
		// }, {
		// 	icon: (<span className="fa fa-address-book-o fa-2x" />),
		// 	text: '我的审批',
		// 	path:'/mobile/mobile-approval'
		// }]
		let { employeeTips,employeeImportantTips } = this.props.employee;
		return (<div>
			<div className="MobileTimeTitle">您今天的上班时间：</div>
			<div className="MobileTime">{employeeTips?employeeTips.shedule:"暂无数据"}</div>
			<div className="MobileTimes">
			剩余普通调休：<span>{employeeTips?employeeTips.common_relaxation_leftover:0}小时</span>，
			剩余因公调休：<span>{employeeTips?employeeTips.formal_relaxation_leftover:0}小时</span>，
			将过期普通调休：<span>{employeeTips?employeeTips.common_relaxation_expired:0}小时</span>，
			将过期因公调休：<span>{employeeTips?employeeTips.formal_relaxation_expired:0}小时</span>，
			剩余年假：<span>{employeeTips?employeeTips.yearvacation_leftover:0}天</span></div>
    		<Grid data={navList} columnNum={3} onClick={_el =>store.dispatch(push(_el.path))} />
			{/* <List renderHeader={() => '重要通知'} className="my-list">
    		{employeeImportantTips?
				employeeImportantTips.map(item => {
					return (
						<Item arrow="horizontal" key={item} onClick={() => {}}><span className="fa fa-circle-o" /> {item}</Item>
					)
				}):	
				<Item>暂无数据</Item>
    		}
		    </List> */}
		</div>)
	}
}
const mapStateToProps = state => {
	return {
		employee: state.employee,
		user: state.user
	}
}

const mapDispatchToProps = {
	fetchEmployeeTips,
	fetchEmployeeImportantTips
}

// export default MobileWrapper(MobileHomeA);
export default MobileWrapper(connect(mapStateToProps, mapDispatchToProps)(MobileHome));


// WEBPACK FOOTER //
// ./src/routes/Mobile/MobileHome.js